import { useTranslation } from "react-i18next";
import { Lockup } from "@/atoms/lockup";

/**
 * The root of pay.gymkee.io.
 *
 * Nobody arrives here on purpose: every real visit carries a link. So the page says who runs the
 * money and stops. The lockup at 120 and one line, on paper, and nothing else on it: no
 * navigation to a marketing site, no login, no footer.
 */

export function HomePage() {
  const { t } = useTranslation();

  return (
    <div className="bg-surface-paper px-gk-4 flex min-h-screen flex-col items-center justify-center">
      <div className="ds-reveal gap-gk-4 flex flex-col items-center">
        <Lockup width={120} />
        <p className="max-w-[48ch] text-center text-[15px] leading-[1.55] text-[var(--gk-text-secondary)]">
          {t("gymkeePay.common.homeLine")}
        </p>
      </div>
    </div>
  );
}
